import * as types from './types';
import { TagEntity } from 'src/firebase/db/Tags';
import { MessageEntity } from 'src/firebase/db/Messages';

import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';

export type Actions =
  | GetTags
  | SuccessGetTags
  | FailGetTags
  | CreateTag
  | SuccessCreateTag
  | FailCreateTag
  | UpdateTag
  | SuccessUpdateTag
  | FailUpdateTag
  | CreatePushMessage
  | SuccessPushMessage
  | FailPushMessage
  | GetPushMessages
  | SuccessGetPushMessages
  | FailGetPushMessages
  | InitMaster;

/**
 * Get
 */
interface GetTags {
  type: typeof types.GET_TAGS;
}
export const getTags = () => ({
  type: types.GET_TAGS,
});

interface SuccessGetTags {
  type: typeof types.SUCCESS_GET_TAGS;
  payload: APISuccessfulResponse<TagEntity[]>;
}
export const successGetTags = (payload: SuccessGetTags['payload']) => ({
  type: types.SUCCESS_GET_TAGS,
  payload,
});

interface FailGetTags {
  type: typeof types.FAIL_GET_TAGS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetTags = (payload: FailGetTags['payload']) => ({
  type: types.FAIL_GET_TAGS,
  payload,
});

/**
 * Create
 */
interface CreateTag {
  type: typeof types.CREATE_TAG;
  payload: Partial<TagEntity>;
}
export function createTag(payload: CreateTag['payload']) {
  return {
    type: types.CREATE_TAG,
    payload,
  };
}

interface SuccessCreateTag {
  type: typeof types.SUCCESS_CREATE_TAG;
  payload: APISuccessfulResponse<TagEntity>;
}
export function successCreateTag(payload: SuccessCreateTag['payload']) {
  return {
    type: types.SUCCESS_CREATE_TAG,
    payload,
  };
}

interface FailCreateTag {
  type: typeof types.FAIL_CREATE_TAG;
  payload: ValidationResponse | APIFailedResponse;
}
export function failCreateTag(payload: FailCreateTag['payload']) {
  return {
    type: types.FAIL_CREATE_TAG,
    payload,
  };
}

/**
 * Update
 */
interface UpdateTag {
  type: typeof types.UPDATE_TAG;
  payload: Partial<TagEntity>;
}
export function updateTag(payload: UpdateTag['payload']) {
  return {
    type: types.UPDATE_TAG,
    payload,
  };
}

interface SuccessUpdateTag {
  type: typeof types.SUCCESS_UPDATE_TAG;
  payload: APISuccessfulResponse<TagEntity>;
}
export function successUpdateTag(payload: SuccessUpdateTag['payload']) {
  return {
    type: types.SUCCESS_UPDATE_TAG,
    payload,
  };
}

interface FailUpdateTag {
  type: typeof types.FAIL_UPDATE_TAG;
  payload: ValidationResponse | APIFailedResponse;
}
export function failUpdateTag(payload: FailUpdateTag['payload']) {
  return {
    type: types.FAIL_UPDATE_TAG,
    payload,
  };
}

/**
 * Update
 */
interface CreatePushMessage {
  type: typeof types.CREATE_PUSH_MESSAGE;
  payload: MessageEntity;
}
export function createPushMessage(payload: CreatePushMessage['payload']) {
  return {
    type: types.CREATE_PUSH_MESSAGE,
    payload,
  };
}

interface SuccessPushMessage {
  type: typeof types.SUCCESS_PUSH_MESSAGE;
  payload: APISuccessfulResponse<MessageEntity>;
}
export function successPushMessage(payload: SuccessPushMessage['payload']) {
  return {
    type: types.SUCCESS_PUSH_MESSAGE,
    payload,
  };
}

interface FailPushMessage {
  type: typeof types.FAIL_PUSH_MESSAGE;
  payload: ValidationResponse | APIFailedResponse;
}
export function failPushMessage(payload: FailPushMessage['payload']) {
  return {
    type: types.FAIL_PUSH_MESSAGE,
    payload,
  };
}

interface GetPushMessages {
  type: typeof types.GET_PUSH_MESSAGES;
}
export function getPushMessages() {
  return {
    type: types.GET_PUSH_MESSAGES,
  };
}

interface SuccessGetPushMessages {
  type: typeof types.SUCCESS_GET_PUSH_MESSAGES;
  payload: APISuccessfulResponse<MessageEntity>;
}
export function successGetPushMessages(payload: SuccessGetPushMessages['payload']) {
  return {
    type: types.SUCCESS_GET_PUSH_MESSAGES,
    payload,
  };
}

interface FailGetPushMessages {
  type: typeof types.FAIL_GET_PUSH_MESSAGES;
  payload: APIFailedResponse;
}
export function failGetPushMessages(payload: FailGetPushMessages['payload']) {
  return {
    type: types.FAIL_GET_PUSH_MESSAGES,
    payload,
  };
}

interface InitMaster {
  type: typeof types.INIT_MASTER;
}
export function initMaster() {
  return {
    type: types.INIT_MASTER,
  };
}
